export class BaseHashParamsModel extends Object {
  constructor(params) {
    super(params);

    Object.assign(this, params);
  }

  toString(): String {
    let hash: String = '';

    let count: Number = 0;

    for (const key in this) {
      if (this[key]) {
        if (count === 0) {
          hash += '#';
        } else {
          hash += '&'
        }

        if (key === this[key]) {
          hash += key;
        } else {
          hash += `${key}=${this[key]}`
        }

        count++;
      }
    }

    return hash;
  }
}
